{
    "ReporttypeDesktopwallboard": "Desktop Wallboard (não licenciado)",
    "ReporttypeDashboard": "Painel",
    "ReporttypeActivecalllist": "Lista de chamadas ativa (não licenciada)",
    "ReporttypeHistoriccalllist": "Lista de chamadas históricas",
    "ReporttypeUnreturnedlostcalls": "Chamadas perdidas não retornadas (não licenciadas)",
    "ReporttypeExtensionlist": "Lista de extensões (sem licença)",
    "ReporttypeAcdagentlist": "Lista de Agentes ACD (Não Licenciado)",
    "ReporttypeHuntgrouplist": "Lista de grupos de busca (sem licença)",
    "ReporttypeTrunkinterfacelist": "Lista de Interfaces de Tronco",
    "ReporttypeCallsbytelno": "Chamadas por telefone",
    "ReporttypeCallsbyddi": "Chamadas por DDI (não licenciadas)",
    "ReporttypeCallsbyhalfhourinterval": "Chamadas por Intervalo de ½ Hora",
    "ReporttypeCallsbyhalfhourplusday": "Chamadas por ½ hora + dia",
    "ReporttypeCallsbyday": "Chamadas por dia",
    "ReporttypeCallsbyweek": "Chamadas por semana",
    "ReporttypeCallsbymonth": "Chamadas por mês",
    "ReporttypeCallsbyaccountcode": "Chamadas por código de conta (sem licença)",
    "ReporttypeAcddndactivitylog": "Registro de atividades de ACD\/DND (não licenciado)",
    "ReporttypeAcsnacodeusage": "Uso de código ACS N\/A (não licenciado)",
    "ReporttypeExternalcontent": "Conteúdo externo (via URL)",
    "ReporttypeUnlicensedformattingstring": "|1 (Não licenciado)",
    "GroupLive": "Eventos ao vivo",
    "GroupEntity": "Entidade",
    "GroupLogs": "Histórico",
    "GroupInterval": "Intervalo",
    "GroupMisc": "Diversos",
    "NAME": "ReportTypes"
}